import React, { useMemo, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Config from "./config";

import { AppProvider, useAppContext } from "./AppContext";

import ReactGA from "react-ga4";

const TRACKING_ID = "G-3CVRJ7EBZ9";
ReactGA.initialize(TRACKING_ID);

const AppRoutes = () => {
  const { routes, components, chimeraserv, user } = useAppContext();

  return (
    <Routes>
      <Route path="/" element={routes[0].element} />
      {routes.map((route, key) => (
        <Route key={key} path={route.path} element={route.element} />
      ))}

      <Route path="*" element={components.setting[0].element} />
    </Routes>
  );
};

const App = () => {
  useEffect(() => {
    console.log("App mounted");
  }, []);

  return (
    <AppProvider>
      <Router basename={Config.base}>
        <AppRoutes />
      </Router>
    </AppProvider>
  );
};

export default App;
// "get": "http://3.134.236.125:7000",
//   "post": "http://3.134.236.125:4040",
